import { render, staticRenderFns } from "./ApproveOrderNFSeModal.vue?vue&type=template&id=5345d87c&"
import script from "./ApproveOrderNFSeModal.vue?vue&type=script&lang=js&"
export * from "./ApproveOrderNFSeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports